
import { useState, useMemo } from 'react';
import { TimeSlot, DayOfWeek } from '@/models/Schedule';

interface UseScheduleFiltersProps {
  timeSlots: TimeSlot[];
}

export const useScheduleFilters = ({ timeSlots }: UseScheduleFiltersProps) => {
  const [selectedDay, setSelectedDay] = useState<DayOfWeek | 'all'>('all');
  const [selectedWorkoutType, setSelectedWorkoutType] = useState<string | 'all'>('all');

  const filteredTimeSlots = useMemo(() => {
    return timeSlots.filter((slot) => {
      const dayMatch = selectedDay === 'all' || slot.day === selectedDay;
      const workoutTypeMatch = selectedWorkoutType === 'all' || slot.workoutTypeId === selectedWorkoutType;
      
      return dayMatch && workoutTypeMatch && slot.isActive;
    });
  }, [timeSlots, selectedDay, selectedWorkoutType]);

  const clearFilters = () => {
    setSelectedDay('all');
    setSelectedWorkoutType('all');
  };

  return {
    selectedDay,
    selectedWorkoutType,
    filteredTimeSlots,
    setSelectedDay,
    setSelectedWorkoutType,
    clearFilters,
  };
};
